module.exports = __webpack_public_path__ + "static/img/katun06.62219a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun06.jpg
// module id = o5gI
// module chunks = 0